import React from "react";
import routePaths from "../global/routePath";
import Alerts from "../pages/alerts/alerts";

const Login = React.lazy(() => import("../pages/auth/Login"));
const Signup = React.lazy(() => import("../pages/auth/Signup"));
const ResetPassword = React.lazy(() => import("../pages/auth/ResetPassword"));
const Unauthorized = React.lazy(() => import("../pages/auth/Unauthorized"));

const Home = React.lazy(() => import("../pages/home"));
const InstitutionCategories = React.lazy(() => import("../pages/institutions/InstitutionCategories"));
const InstitutionList = React.lazy(() => import("../pages/institutions/InstitutionList"));
const InstitutionDetails = React.lazy(() => import("../pages/institutions/InstitutionDetails"));
const CreateInstitution = React.lazy(() => import("../pages/institutions/CreateInstitution"));

const Screens = React.lazy(() => import("../pages/screens/screens"));
const ScreenDetails = React.lazy(() => import("../pages/screens/screen-details"));
const ScreenConfig = React.lazy(() => import("../pages/screens/screen-config"));
const ScreenCategories = React.lazy(() => import("../pages/screens/ScreenCategories"));
const ScreenStatus = React.lazy(() => import("../pages/screens/status"));

const Frames = React.lazy(() => import("../pages/frames/frames"));
const CreateFrame = React.lazy(() => import("../pages/frames/create-frame"));
const EditFrame = React.lazy(() => import("../pages/frames/edit-frame"));
const FrameCategories = React.lazy(() => import("../pages/frames/FrameCategories"));
const FrameScreens = React.lazy(() => import("../pages/frames/frame-screens"));
const ScreenFrameConfig = React.lazy(() => import("../pages/screen-frame-config/screen-frame-config"));
const FrameDetails = React.lazy(() => import("../pages/frames").then(m => ({ default: m.FrameDetails })));

const User = React.lazy(() => import("../pages/users/User"));
const AlertDetails = React.lazy(() => import("../pages/alerts/alert-details"));

const PlaybackHistory = React.lazy(() => import("../pages/playback-history/playback-history"));
const PlaybackHistoryDetail = React.lazy(() => import("../pages/playback-history/components/PlaybackHistoryDetail"));
const ContentLibrary = React.lazy(() => import("../pages/content-library/content-library"));
const FileUsage = React.lazy(() => import("../pages/files/file-usage"));

const ComponentContentHistory = React.lazy(() => import("../pages/component-content/component-content-history"));
const CreateComponentContent = React.lazy(() => import("../pages/component-content/create-component-content"));
const ApprovalPendings = React.lazy(() => import("../pages/component-content/approval-pendings"));

export type Route = {
  path: string;
  component: React.ReactNode;
};
export const publicRoute: Route[] = [{
  path: routePaths.auth.signin,
  component: <Login />,
},
{
  path: routePaths.auth.signup,
  component: <Signup />,
},
// {
//   path: '/forgot-password',
//   component: <ForgotPassword />,
// },
{
  path: '/reset-password',
  component: <ResetPassword />,
},
{
  path: '/unauthorized',
  component: <Unauthorized />,
}];

export const privateRoute: Route[] = [
  {
    path: routePaths.home.base,
    component: <Home />,
  },
  {
    path: routePaths.institution.categories,
    component: <InstitutionCategories />,
  },
  {
    path: routePaths.institution.list,
    component: <InstitutionList />,
  },
  {
    path: routePaths.institution.create,
    component: <CreateInstitution />,
  },
  {
    path: routePaths.institution.edit(':id'),
    component: <CreateInstitution />,
  },
  {
    path: routePaths.institution.detail(':id'),
    component: <InstitutionDetails />,
  },
  {
    path: routePaths.screen.categories,
    component: <ScreenCategories />,
  },
  {
    path: routePaths.screen.list,
    component: <Screens/>,
  },
  {
    path: routePaths.screen.status,
    component: <ScreenStatus />,
  },
  {
    path: routePaths.screen.detail(':id'),
    component: <ScreenDetails />,
  },
  {
    path: routePaths.screen.config(':id'),
    component: <ScreenConfig />,
  },
  {
    path: routePaths.frames.categories,
    component: <FrameCategories />,
  },
  {
    path: routePaths.frames.base,
    component: <Frames />,
  },
  {
    path: routePaths.frames.create,
    component: <CreateFrame />,
  },
  {
    path: routePaths.frames.edit(':id'),
    component: <EditFrame />,
  },
  {
    path: routePaths.frames.detail(':id'),
    component: <FrameDetails />,
  },
  {
    path: routePaths.frames.screens(':id'),
    component: <FrameScreens />,
  },
  {
    path: routePaths.screenFrameConfig.base(':id'),
    component: <ScreenFrameConfig />,
  },
  {
    path: routePaths.users.base,
    component: <User />,
  },
  {
    path: routePaths.alerts.base,
    component: <Alerts />,
  },
  {
    path: routePaths.alerts.detail(':id'),
    component: <AlertDetails />,
  },
  {
    path: routePaths.playbackHistory.base,
    component: <PlaybackHistory />,
  },
  {
    path: routePaths.playbackHistory.detail,
    component: <PlaybackHistoryDetail />,
  },
  {
    path: routePaths.componentContentHistory.base,
    component: <ComponentContentHistory />,
  },
  {
    path: routePaths.componentContent.create,
    component: <CreateComponentContent />,
  },
  {
    path: routePaths.componentContent.approvalPendings,
    component: <ApprovalPendings />,
  },
  {
    path: routePaths.contentLibrary.base,
    component: <ContentLibrary />,
  },
  {
    path: routePaths.contentLibrary.usage,
    component: <FileUsage />,
  },
];
